import { ElementType } from "react";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

interface Breadcrumb {
  text: any;
  route?: string;
  onClick?: () => void;
  style?: React.CSSProperties;
  icon?: ElementType;
  iconOnClick?: () => void; // Add iconOnClick for handling icon clicks
}

export const getBreadCrumbs = (pathname: string, navigate: (to: string) => void, type?: string, search?: string) => {
  console.log("pathname", pathname)
  console.log(type)
  let breadcrumbArray: Breadcrumb[] = [];


  switch (pathname) {
    case "/dashboard":
      breadcrumbArray = [{ text: "Dashboard" }];
      break;

    case "/discovery":
      const hasScanId = search ? new URLSearchParams(search).has("scan_id") : false;
      breadcrumbArray = hasScanId
        ? [
            {
              icon: ArrowBackIcon,
              text: "Inventory",
              iconOnClick: () => navigate("/on-premises/scans"),
            },
          ]
        : [
            {
              text: "Inventory",
            },
          ];
      break;

    case "/compliance-dashboard":
      breadcrumbArray = [
        { text: "Compliance" }
      ];
      break;

    case "/organization/agent":
      breadcrumbArray = [{ text: "Agents" }];
      break;

    case "/on-premises/newscan":
      breadcrumbArray = [
        { text: "New Scan" },
      ];
      break;
    case "/on-premises/new-newscan":
      breadcrumbArray = [
        { text: "New Scan" },
      ];
      break;

    case "/on-premises/installed-software":
      breadcrumbArray = [
        { text: "Installed Software" },
      ];
      break;

    case "/on-premises/assets":
      breadcrumbArray = [
        { text: "Assets" },
      ];
      break;

    case "/on-premises/asset_v2":
      breadcrumbArray = [
        { text: "Asset Inventory" },
      ];
      break;

    case "/on-premises/configdiff":
      breadcrumbArray = [
        { text: "Config Diff" },
      ];
      break;

    case "/on-premises/credentials":
      breadcrumbArray = [
        { text: "Credentials" },
      ];
      break;

    case "/organization/vpn":
      breadcrumbArray = [{ text: "VPN" }];
      break;

    case "/organization/custom-ports":
      breadcrumbArray = [{ text: "Custom Ports" }];
      break;

    case "/organization/roles":
      breadcrumbArray = [{ text: "Roles Management" }];
      break;

    case "/organization/regions":
      breadcrumbArray = [{ text: "Regions Management" }];
      break;

    case "/compliance-dashboard/NIST":
      breadcrumbArray = [{ text: type }];
      break;

    case "/compliance-dashboard/CIS":
      breadcrumbArray = [{ text: type }];
      break;


    case "/on-premises/scans":
      breadcrumbArray = [{ text: "Scans" }];
      break;

    case "/on-premises/acceptedrisk":
      breadcrumbArray = [{ text: "Risk Acceptance" }];
      break;



    case "/on-premises/security-posture":
      breadcrumbArray = [{ text: "Posture Management" }];
      break;
    case "/cloud/cloud-resources":
      breadcrumbArray = [{ text: "Resources" }];
      break;
    case "/cloud/scans":
      breadcrumbArray = [{ text: "Cloud Scans" }];
      break;
    case "/cloud/security-posture":
      breadcrumbArray = [{ text: "Security Posture" }];
      break;





    case "/onprem/schedule":
      breadcrumbArray = [
        {
          icon: ArrowBackIcon,
          text: "Create Schedule",
          iconOnClick: () => navigate("/on-premises/scans?switch=on"),
        },
      ];
      break;

    case pathname.match(/^\/onprem\/scan\/.+/)?.input:
      breadcrumbArray = [
        { text: "Security Information" },
      ];
      break;
    // case pathname.match(/^\/cloud\/scan\/.+/)?.input:
    //   breadcrumbArray = [
    //     { text: "Scan Details" },
    //   ];
    //   break;




    case "/on-premises/cve":
      breadcrumbArray = [
        // { text: "On Premises", onClick: () => navigate("/on-premises") },
        { text: "Vulnerability" }
      ];
      break;


    case "/on-premises/configdiff/show-diff":
      breadcrumbArray = [{ text: "Config Diff" }];
      break;

    case "/organization/user-management":
      breadcrumbArray = [
        // { text: "Organization", onClick: () => navigate("/organization") },
        { text: "User Management" }
      ];
      break;
    case "/organization/reports":
      breadcrumbArray = [
        // { text: "Organization", onClick: () => navigate("/organization") },
        { text: "Reports" }
      ];
      break;

    case "/organization/master-config":
      breadcrumbArray = [{ text: "Config Template" }];
      break;

    case "/cloud/rule-management":
      breadcrumbArray = [
        { text: "Rule Management" },
      ];
      break;

    default:
      breadcrumbArray = [{ text: "Home", onClick: () => navigate("/") }];
  }
  return breadcrumbArray;
};